import {
  ADD_TAG_FILTER,
  REMOVE_TAG_FILTER,
  SET_TAG_FILTERS,
} from 'actionTypes';

export function addTagFilter(tag) {
  return {
    type: ADD_TAG_FILTER,
    tag,
  };
}

export function removeTagFilter(tag) {
  return {
    type: REMOVE_TAG_FILTER,
    tag,
  };
}

export function setTagFilters(tags) {
  return {
    type: SET_TAG_FILTERS,
    tags,
  };
}



// WEBPACK FOOTER //
// ./src/actions/filteringActions.js